<template>
  <div class="mobileReview botPage">
    <mbHeader :title="$t('review_manage')" :left="true" :lang="true"></mbHeader>
    <reviewProducts></reviewProducts>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import reviewProducts from "../Profile/reviewProducts";

export default {
  name: "mobileReview",
  components: {mbHeader, reviewProducts},
}
</script>

<style scoped lang="less">
.mobileReview{
  min-height: 100vh;
  padding: 66px 16px 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileReview.vue